import Tooltip from 'bootstrap/js/dist/tooltip';

const playerSearchListItemTemplate = document.querySelector(
    '.player-search-list-item-template *'
);
for (const playerSearch of document.querySelectorAll('.player_search')) {
    const licenseGroupId = playerSearch.getAttribute('data-license-group-id');
    const searchInput = playerSearch.querySelector('input');
    const playersSearchList = playerSearch.querySelector(
        '.players_search_list_inner'
    );
    const playersList = document.querySelector(
        '#license_group_' + licenseGroupId + '_players_list'
    );
    let foundPlayers = [];

    if (!players.length) {
        playerSearch.innerHTML =
            '<div class="alert alert-info" role="alert">Es wurden noch keine Spieler in der Lernsoftware angelegt.</div>';
    }

    const selectPlayer = function (player) {
        searchInput.value = '';
        const playerGroup = playerGroups.find(
            pg => pg.id === player.player_group_id
        );
        const newPlayerListItem = playerSearchListItemTemplate.cloneNode(true);
        newPlayerListItem.querySelector('[name="visible_players[]"]').value =
            player.id;
        newPlayerListItem.querySelector('[name="visible_players[]"]').disabled =
            false;
        newPlayerListItem.querySelector('.player-name').innerHTML =
            getPlayerElementContent(player, playerGroup);
        newPlayerListItem.id =
            'player-list-item-' + licenseGroupId + '-' + player.id;
        playersSearchList.parentElement.classList.add('d-none');
        playersList.prepend(newPlayerListItem);
        let deleteTooltip;
        for (const tooltipTrigger of newPlayerListItem.querySelectorAll(
            '[data-bs-toggle="tooltip"]'
        )) {
            deleteTooltip = new Tooltip(tooltipTrigger);
        }
        newPlayerListItem
            .querySelector('[data-delete]')
            .addEventListener('click', function () {
                deleteTooltip.hide();
                setTimeout(() =>
                    document
                        .querySelector(
                            '#player-list-item-' +
                                licenseGroupId +
                                '-' +
                                player.id
                        )
                        .remove()
                );
            });
    };

    const refreshPlayerList = function () {
        const alreadySelected = [
            ...playersList.querySelectorAll('[name="visible_players[]"]'),
        ].map(as => as.value);
        playersSearchList.innerHTML = '';
        foundPlayers = players.filter(
            player =>
                player.name
                    .toLowerCase()
                    .includes(searchInput.value.toLowerCase()) &&
                !alreadySelected.includes(player.id)
        );
        for (const player of foundPlayers) {
            const playerSearchItem = document.createElement('button');
            const playerGroup = playerGroups.find(
                pg => pg.id === player.player_group_id
            );
            playerSearchItem.innerHTML = getPlayerElementContent(
                player,
                playerGroup
            );
            playerSearchItem.setAttribute('type', 'button');
            playerSearchItem.classList.add('dropdown-item');
            playerSearchItem.addEventListener('click', function () {
                selectPlayer(player);
            });
            playersSearchList.appendChild(playerSearchItem);
        }
    };

    const getPlayerElementContent = function (player, playerGroup) {
        return (
            '<img alt="' +
            player.name +
            '" style="width: 1em; height: 1em;object-fit: contain" class="me-1" src="' +
            player.picture_uri +
            '"/>' +
            player.name +
            ' - ' +
            '<img alt="' +
            playerGroup.name +
            '" style="width: 1em; height: 1em;object-fit: contain" class="me-1 ms-1" src="' +
            playerGroup.picture_uri +
            '"/>' +
            playerGroup.name
        );
    };

    searchInput.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter') {
            return;
        }

        event.preventDefault();
        if (!foundPlayers.length) {
            return;
        }
        selectPlayer(foundPlayers[0]);
        refreshPlayerList();
    });

    searchInput.addEventListener('input', function () {
        refreshPlayerList();
    });
    searchInput.addEventListener('focus', function () {
        refreshPlayerList();
        playersSearchList.parentElement.classList.remove('d-none');
    });
    document.addEventListener('click', function (event) {
        if (!playerSearch.contains(event.target)) {
            playersSearchList.parentElement.classList.add('d-none');
        }
    });
}
